<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="MessageSquareIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1 class="md:lg m-0">Idiomas</h1>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base">
            Insira o idioma e o seu nível de proficiência. Clique em
            <b>Adicionar</b> para salvar o idioma.
          </span>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-w="3" vs-xs="12" class="mb-2">
          <label class="vs-select--label">Idioma</label>
          <v-select
            :options="defaults_languages"
            :reduce="language => language.value"
            v-model="payload.language"
          />
        </vs-col>

        <vs-col vs-w="3" vs-xs="12" class="mb-2">
          <label class="vs-select--label">Proficiência</label>
          <v-select
            :options="levels"
            :reduce="level => level.value"
            v-model="payload.level"
          />
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-w="3"
          vs-xs="12"
          class="mb-2"
        >
          <vs-button
            color="primary"
            type="border"
            class="btn-customized"
            @click="saveLanguage"
            >Adicionar</vs-button
          >
        </vs-col>

        <vs-col vs-w="12" class="mt-8 mb-3">
          <vs-chip
            closable
            v-for="(language, index) in languages"
            :key="`language-${index}`"
            class="mt-1 ml-1"
            color="#708090"
            @click="onRemoveLanguage(index)"
          >
            {{ language.name }}
          </vs-chip>
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap mt-2">
      <backward-button @click="handleBackward" />
      <forward-button @click="handleForward" />
    </div>

    <vs-popup title="Remover Idioma" :active.sync="popupActive">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="start"
          vs-w="12"
        >
          <p>Deseja Remover o idioma?</p>
        </vs-col>

        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="doRemoveLanguage"
            color="danger"
            type="filled"
          >
            Remover
          </vs-button>
          <vs-button
            class="mx-1"
            @click="popupActive = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";

export default {
  created() {
    window.scroll(0, 0);
    this.fetchLanguages();
    this.googleAnalytics();
  },
  data() {
    return {
      languages: [],
      payload: {
        index: 0,
        name: "",
        level: "",
        language: ""
      },
      language_to_remove: {},
      popupActive: false,
      levels: [
        { value: "Básico", label: "Básico" },
        { value: "Intermediário", label: "Intermediário" },
        { value: "Avançado", label: "Avançado" },
        { value: "Fluente", label: "Fluente" },
        { value: "Nativo", label: "Nativo" }
      ]
    };
  },
  computed: {
    ...mapState("language", ["defaults_languages"])
  },
  methods: {
    ...mapActions("progress", ["calculateProgress"]),

    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    },

    async handleForward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/completeStep");

      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    },

    fetchLanguages() {
      this.$vs.loading({ text: "Carregando..." });

      const label = sessionStorage.getItem("label");

      this.$http
        .get(`api/v1/talent/${label}/user/talent?step=languages`)
        .then(response => {
          this.$vs.loading.close();

          const { languages } = response.data.data;
          this.languages = languages;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    saveLanguage() {
      if (this.payload.level == "") {
        this.$vs.notify({
          color: "danger",
          title: "Falha ao salvar idioma",
          text: "Para salvar é necessário escolher uma proficiência!",
          position: "top-right"
        });
      }

      if (this.payload.language == "") {
        this.$vs.notify({
          color: "danger",
          title: "Falha ao salvar idioma",
          text: "Para salvar é necessário escolher um idioma!",
          position: "top-right"
        });
      }

      if (this.payload.language != "" && this.payload.level != "") {
        const name = this.payload.language.concat(` ${this.payload.level}`);

        this.payload = {
          ...this.payload,
          name
        };

        const { company_label } = this.$router.history.current.params;

        this.$vs.loading({
          text: "Salvando..."
        });

        this.$http
          .post(`api/v1/talent/${company_label}/user/talent?step=languages`, {
            languages: [
              {
                ...this.payload
              }
            ]
          })
          .then(async response => {
            this.$vs.loading.close();

            this.payload = {
              ...this.payload,
              id: response.data.data.languages[0].id,
              index: response.data.data.languages[0].index
            };

            this.languages.push(this.payload);

            await this.$store.dispatch("language/store", {
              ...this.payload
            });

            this.payload = {
              index: 0,
              name: "",
              level: "",
              language: ""
            };

            this.calculateProgress({
              field: "language",
              value: this.languages
            });
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },

    onChange(e) {
      if (e.target.name == "language")
        this.language = e.target.value.length > 0 ? e.target.value : "";
      if (e.target.name == "nivel")
        this.nivel = e.target.value.length > 0 ? e.target.value : "";
    },

    onRemoveLanguage(index) {
      this.language_to_remove = this.languages[index];
      this.popupActive = true;
    },

    async doRemoveLanguage() {
      try {
        this.$vs.loading({
          text: "Removendo..."
        });
        const result = await this.$http.delete(
          `api/v1/talents-languages/${this.language_to_remove.id}`
        );

        if (result.status == 200) {
          this.$vs.loading.close();
          this.popupActive = false;

          const index = this.languages.findIndex(
            language => language.id === this.language_to_remove.id
          );

          this.languages = [
            ...this.languages.slice(0, index),
            ...this.languages.slice(index + 1)
          ];

          this.$store.dispatch("language/delete", { index });
          this.calculateProgress({ field: "language", value: this.languages });
          this.language_to_remove = {};
        }
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao remover o idioma",
          text:
            error.response.data.message ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/languages`)
        : this.$ga.page(`${company_label}/step/languages`);
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    }
  },
  components: {
    ModelSelect,
    BackwardButton,
    ForwardButton,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
